// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__j5AG6","signin_btn":"styles_signin_btn__3QhyQ"};